<template>
    <section class="formatter">
        <div class="d-flex gap-5">
            <div class="editor-row customize-editor-minimize">
                <div class="editor-row-title">{{ $t('auto.dateAddAddingValue') }}</div>
                <TiptapEditor
                    placeholder="Add Value or pick from a variable"
                    :show-attributes="true"
                    v-model="clone.add.value"
                    :show-emoji="false"
                    automation-mode
                />
            </div>
            <div class="editor-row customize-editor-minimize">
                <div class="editor-row-title">{{ $t('auto.dateAddAddingUnitType') }}</div>
                <CustomPicker v-model="clone.add.unit" :items="unitTypes" idKey="id" labelKey="label" />
            </div>
        </div>
        <div class="d-flex gap-5 groups">
            <FormatPickerInput v-model="clone.add.fromFormat" title="From Format" />
            <FormatPickerInput v-model="clone.add.toFormat" title="To Format" />
        </div>
        <div class="d-flex gap-5 groups">
            <LocalePickerInput v-model="clone.add.fromLocale" title="From Locale" />
            <LocalePickerInput v-model="clone.add.toLocale" title="To Locale" />
        </div>
    </section>
</template>

<script>
import log2 from "../../../../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../../../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
import CustomPicker from "../../../../../../../../../components/pickers/CustomPicker.vue";
import FormatPickerInput from "../inputs/FormatPickerInput.vue";
import LocalePickerInput from "../inputs/LocalePickerInput.vue";

const log = log2("Date.Add.vue");
export default {
    name: "DateAdd.vue",
    components: { CustomPicker, TiptapEditor, FormatPickerInput, LocalePickerInput },
    props: ["value"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            mode: "date.add", //date.add,date.sub,date.format,date.compare,startOf,endOf,date.diff
            inputs: [""],
            add: {
                value: "1",
                unit: "days",
                fromFormat: "YYYY-MM-DD",
                toFormat: "YYYY-MM-DD",
                fromLocale: "en",
                toLocale: "en",
            },
            sub: {
                value: "1",
                unit: "days",
                fromFormat: "YYYY-MM-DD",
                toFormat: "YYYY-MM-DD",
                fromLocale: "en",
                toLocale: "en",
            },
            format: {
                fromFormat: "YYYY-MM-DD",
                toFormat: "YYYY-MM-DD",
                toTimezone: "UTC",
                fromTimezone: "UTC",
                fromLocale: "en",
                toLocale: "en",
            },
            compare: {
                fromFormat: "YYYY-MM-DD",
                toFormat: "YYYY-MM-DD",
                checkPart: ["year", "month", "day", "hour", "minute", "second"],
            },
            startOf: {
                unit: "day",
                fromFormat: "YYYY-MM-DD",
                toFormat: "YYYY-MM-DD",
                timezone: "UTC",
            },
            endOf: {
                unit: "day",
                fromFormat: "YYYY-MM-DD",
                toFormat: "YYYY-MM-DD",
                timezone: "UTC",
            },
            diff: {
                fromFormat: "YYYY-MM-DD",
                toFormat: "YYYY-MM-DD",
                unit: "days",
            },
        };
        if (!clone.add) {
            clone.add = {
                value: "1",
                unit: "days",
                fromFormat: "YYYY-MM-DD",
                toFormat: "YYYY-MM-DD",
                fromLocale: "en",
                toLocale: "en",
            };
        }
        return {
            clone,
            unitTypes: [
                {
                    id: "days",
                    label: "Days",
                    description: "Add days to a date",
                },
                {
                    id: "months",
                    label: "Months",
                    description: "Add months to a date",
                },
                {
                    id: "years",
                    label: "Years",
                    description: "Add years to a date",
                },
                {
                    id: "hours",
                    label: "Hours",
                    description: "Add hours to a date",
                },
                {
                    id: "minutes",
                    label: "Minutes",
                    description: "Add minutes to a date",
                },
                {
                    id: "seconds",
                    label: "Seconds",
                    description: "Add seconds to a date",
                },
            ],
        };
    },
    methods: {},
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
        value(newValue) {
            if (_.isEqual(newValue, this.clone)) return;
            this.clone = _.cloneDeep(newValue);
        },
    },
};
</script>

<style lang="scss" scoped>
section.formatter {
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 100%;

    .groups {
        width: 100%;
        display: flex;
        gap: 5px;
        justify-content: space-between;

        .format-picker-section {
            width: 100%;
        }

        .locale-picker-section {
            width: 100%;
        }
    }
}
</style>
